import React from 'react';

export default function Image({image}) {
 
  return (
    <div>
        <img src={image} alt="" />
    </div>
  );
};